import React, { useState } from "react";
import { FaUpload } from "react-icons/fa"; // Importing Upload Icon
// import './CreateProfilePage.css';

const Mediaupload = () => {
    const [fileName, setFileName] = useState("");

    const handleUploadClick = () => {
        const choice = window.confirm("Do you want to upload from local device? Click 'Cancel' for cloud storage.");
        if (choice) {
            const input = document.createElement("input");
            input.type = "file";
            input.accept = "image/*,video/*";
            input.onchange = (e) => {
                setFileName(e.target.files[0].name);
            };
            input.click();
        } else {
            const url = window.prompt("Enter cloud storage URL:");
            if (url) {
                setFileName(url);
            }
        }
    };

    return (
        <div>
            <input 
                type="text" 
                value={fileName} 
                className="uploadimage" 
                readOnly 
            />
            <buttonT 
                onClick={handleUploadClick} 
                className="upload"
            >
                <FaUpload className="text-gray-600" />
            </buttonT>
            <button style={{ fontFamily: "Poppins", color: "black", fontSize: "15px", width: 100, height: 40}}
            >Create Post</button>
        </div>
    );
};

export default Mediaupload;
